export const REFERRAL_TYPES = {
  GET_USER_REFERRAL_INFO: "GET_USER_REFERRAL_INFO",
  INVITE_USER: "INVITE_USER",
  PROCESS_REFERRAL: "PROCESS_REFERRAL",
  GET_GAMIFICATION_SUMMARY: "GET_GAMIFICATION_SUMMARY",
  REMOVE_INVITATION: "REMOVE_INVITATION",
};